import { useFilter } from "@/utils";

let RegMaster = new RegExp("^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}");
let RegAmex = new RegExp("^3[47]\\d{0,13}");
let RegMaestro = new RegExp("^(?:5[0678]\\d{0,2}|6304|67\\d{0,2})\\d{0,12}");
let RegVisa = new RegExp("^4\\d{0,15}");
let RegDiscover = new RegExp("^(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}");
let RegUnionpay = new RegExp("^62\\d{0,14}");
let RegDinners = new RegExp("^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}");
let RegElo = new RegExp(
  "^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^504175|^627780|^63(6297|6368|6369)|(65003[5-9]|65004[0-9]|65005[01])|(65040[5-9]|6504[1-3][0-9])|(65048[5-9]|65049[0-9]|6505[0-2][0-9]|65053[0-8])|(65054[1-9]|6505[5-8][0-9]|65059[0-8])|(65070[0-9]|65071[0-8])|(65072[0-7])|(65090[1-9]|6509[1-6][0-9]|65097[0-8])|(65165[2-9]|6516[67][0-9])|(65500[0-9]|65501[0-9])|(65502[1-9]|6550[34][0-9]|65505[0-8])|^(506699|5067[0-6][0-9]|50677[0-8])|^(509[0-8][0-9]{2}|5099[0-8][0-9]|50999[0-9])|^65003[1-3]|^(65003[5-9]|65004d|65005[0-1])|^(65040[5-9]|6504[1-3]d)|^(65048[5-9]|65049d|6505[0-2]d|65053[0-8])|^(65054[1-9]|6505[5-8]d|65059[0-8])|^(65070d|65071[0-8])|^65072[0-7]|^(65090[1-9]|65091d|650920)|^(65165[2-9]|6516[6-7]d)|^(65500d|65501d)|^(65502[1-9]|6550[3-4]d|65505[0-8])"
);
let RegHiper = new RegExp("^606282|^637095|^637599|^637568");
function useCardBrand(CardNumber: string) {
  const Number = useFilter(CardNumber, { type: "number" });
  let Brand = null;
  switch (true) {
    case Number.match(RegAmex) !== null:
      Brand = "american express";
      break;
    case Number.match(RegMaster) !== null:
      Brand = "mastercard";
      break;
    case Number.match(RegMaestro) !== null:
      Brand = "maestro";
      break;
    case Number.match(RegVisa) !== null:
      Brand = "visa";
      break;
    case Number.match(RegDiscover) !== null:
      Brand = "discover";
      break;
    case Number.match(RegUnionpay) !== null:
      Brand = "unionpay";
      break;
    case Number.match(RegDinners) !== null:
      Brand = "dinners";
      break;
    case Number.match(RegHiper) !== null:
      Brand = "hipercard";
      break;
    case Number.match(RegElo) !== null:
      Brand = "elo";
      break;
    default:
      Brand = null;
  }

  switch (Brand) {
    case "american express":
      return "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/amex.svg";
    case "mastercard":
      return "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/icone-master.svg";
    case "maestro":
      return "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/maestr.svg";
    case "visa":
      return "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/visa.svg";
    case "discover":
      return "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/discover.svg";
    case "unionpay":
      return "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/unionpay.svg";
    case "dinners":
      return "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/dinner.svg";
    case "hipercard":
      return "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/icone-hipercard.svg";
    case "elo":
      return "https://cdn.pneufree.com.br/LINGLONG/images/Site/icons/geral/icone-elo.svg";
    default:
      return null;
  }
}

export { useCardBrand };
